// src/utils/displayDevicesApi.js
//
// Apple TV floor board display credentials (ADR 0004, sfm-web-backend).
// Served by the versioned sfm-authz service behind Caddy at /api/display/*.
// Every call is authorised on the server from the caller's tenant grants
// (permission manage_display_devices); the UI check is convenience only.

import ApiCall from "./apicall";

export const displayDevicesApi = {
  list: (facilityId) => ApiCall.get(`/display/devices${facilityId ? `?facilityId=${encodeURIComponent(facilityId)}` : ""}`),
  create: ({ facilityId, label }) => ApiCall.post("/display/devices", { facilityId, label }),
  newPairingCode: (id) => ApiCall.post(`/display/devices/${encodeURIComponent(id)}/pairing-code`),
  revoke: (id) => ApiCall.post(`/display/devices/${encodeURIComponent(id)}/revoke`),
  // Device-code pairing (QM decision 2026-10-04): approve the code shown on the TV.
  approveTvCode: ({ userCode, facilityId, label }) => ApiCall.post("/display/pair-requests/approve", { userCode, facilityId, label }),
};

export default displayDevicesApi;
